'use client';

import type { ReactNode } from 'react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../../components/ui/collapsible';
import { Icon } from '../icon/Icon';

export interface FooterSectionProps {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
}

export function FooterSection({ title, children, defaultOpen = false }: FooterSectionProps) {
  return (
    <Collapsible defaultOpen={defaultOpen} className="border-border-subtle border-b sm:border-0">
      <CollapsibleTrigger className="group flex w-full items-center justify-between py-3 sm:pointer-events-none sm:py-0">
        <span className="font-body font-semibold text-base text-foreground leading-[1.4]">{title}</span>
        <Icon name="chevron-up" className="text-subtle-foreground transition-transform group-data-[state=open]:rotate-180 sm:hidden" />
      </CollapsibleTrigger>
      <CollapsibleContent forceMount className="max-sm:data-[state=closed]:hidden">
        <div className="flex flex-col gap-4 pb-3 sm:pt-4 sm:pb-0">{children}</div>
      </CollapsibleContent>
    </Collapsible>
  );
}
